import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCareer } from 'api/Career';

export const fetchCareer = createAsyncThunk(
    'fetchCareer',
    async () => {
        const response = await getCareer();
        return response.data;
    },
    {
        condition: (_, { getState }) => {
            const { career } = getState();
            if (career.data) return false;
        },
    },
);

const careerSlice = createSlice({
    name: 'career',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchCareer.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCareer.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCareer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default careerSlice.reducer;
